import React from 'react';
import { ParagraphStyled } from './Styled';

interface TitleProps {
  children: string;
  fontSize?: number;
}

const Paragraph = (props: TitleProps) => {
  const { children, fontSize = 16 } = props;

  return <ParagraphStyled fontSize={fontSize}>{children}</ParagraphStyled>;
};

Paragraph.defaultProps = {
  children: '',
};

export default Paragraph;
export { Paragraph };
